import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { SidesheetComponent } from '@features/sidesheet/sidesheet.component';
import { MapComponent } from '@features/map/map.component';

@Component({
  selector: 'app-map-page',
  imports: [MapComponent, RouterOutlet, SidesheetComponent],
  templateUrl: './map-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map-page.component.scss',
})
export class MapPageComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  private navigationEnd = toSignal(
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)),
    { initialValue: null },
  );

  routeNetworkIdFromUrl = computed(() => {
    this.navigationEnd();
    const id = this.route.firstChild?.snapshot.paramMap.get('id');
    return isNaN(Number(id)) ? undefined : id;
  });

  closeSidesheet() {
    this.router.navigate(['./'], { relativeTo: this.route });
  }
}
